import { Injectable } from '@angular/core';
import { StorageService } from '@core/utils';
import { ColumnState } from 'ag-grid-community';

export interface IColumnsStorage {
  [key: string]: ColumnState[] | string[];
}

@Injectable()
export class ColumnsStorage {
  private readonly COLUMNS_STATE_KEY = 'columnsState';
  constructor(private readonly storage: StorageService) {}

  async saveColumnState<T>(name: string, state: ColumnState[] | string[]) {
    let currentState = await this._getColumnsState<T>();
    currentState = {
      ...currentState,
      [name]: state,
    };
    this.storage.set(this.COLUMNS_STATE_KEY, currentState);
  }

  async getColumnsState<T>(name: string): Promise<T> {
    const state = await this._getColumnsState();
    return state ? state[name] : [];
  }

  private async _getColumnsState<T>(): Promise<T> {
    return (await this.storage.get(this.COLUMNS_STATE_KEY)) || null;
  }
}
